const globalUserStateObject = {
	geoState : "CA"
}
export default globalUserStateObject
